import * as React from 'react';
import { useTokenExpiryMonitor } from '../../hooks/useTokenExpiryMonitor';

interface TokenExpiryMonitorProps {
    onBannerVisibilityChange?: (isVisible: boolean) => void;
}

/**
 * Mounts the silent token renewal hook so it runs for the lifetime of the
 * authenticated session. Renders nothing - token refresh is invisible to the user.
 * onBannerVisibilityChange is kept for API compatibility but always reports false.
 */
export const TokenExpiryMonitor: React.FunctionComponent<TokenExpiryMonitorProps> = (props) => {
    // Activates the background refresh loop
    useTokenExpiryMonitor();

    // Keep the prop contract intact; banner is never shown
    React.useEffect(() => {
        if (props.onBannerVisibilityChange) {
            props.onBannerVisibilityChange(false);
        }
    }, [props.onBannerVisibilityChange]);

    return null;
};
